export default __webpack_public_path__ + "static/media/chevron-back.eda1941e.svg";